import {
  ConvertInsertConfirmedUser,
  ConvertInsertInitial,
  GetConvertAmountMax,
  GetConvertInitial,
} from "./api";

import http from "config/http";

const convertApi = {
  getConvertAmountMax: async ({ coinId, coinMasterId, sideId }) =>
    await http.get(GetConvertAmountMax({ coinId, coinMasterId, sideId })),

  convertInsertInitial: async (body) =>
    await http.post(ConvertInsertInitial, body),

  convertInsertConfirmedUser: async (body) =>
    await http.post(ConvertInsertConfirmedUser, body),

  getConvertInitial: async () => await http.get(GetConvertInitial),
};

export default convertApi;
